export class MarketingService {
  constructor(client) {
    this.client = client;
  }

  getConfigService() {
    return this.client.get('/marketing/leadList');
  }
  putChangeAmountService(values) {
    return this.client.put(`/config`, values);
  }
}
